import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { downloadCSV,statusCSV,generateCSV } from '../../../../../jsx/reducers/paygAdmin/extract'
import { Button, Box, Typography, LinearProgress} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import PopUp from '../../commonModules/interface/PopUp';
import Dialog from '../../commonModules/interface/Dialog';


class ExtractList extends Component {
    state = { 
        loading: false,
        downloadProcessInventory: false,
        extractPaiment: false,
        timeStart: new Date(),
        timeStop: new Date(),
        typeInfo: "",
        dataset: "",
        processID: "",
        progress: 0,
        itemDownloaded: 0,
        totalItemToDownload: 0,
        linkAvailable :false,

     }


    fetchStatus = (processID) => {
        this.props.statusCSV(processID).then( dataset => {
            console.log({dataset});
            console.log("[INFO] fetchStatus ", dataset);
            const normalise = 100*(dataset.actual / (dataset.total));
            console.log("[INFO] fetchStatus ", dataset.actual," /",dataset.total, " => ",normalise);

            this.setState({progress: normalise, itemDownloaded: dataset.actual, totalItemToDownload: dataset.total})

            if (dataset.status == "COMPLETED") {
                this.setState({linkAvailable: true, progress: 100, itemDownloaded: dataset.total })
            } else {
                setTimeout(() => {
                    this.fetchStatus(processID)
                    }, 3000);
            }
        }).catch( err => {
            console.log("[ERROR], fetchStatus, ",err)
        })
    }

    fetchDataStoreHouse = (info, dates) => {
        this.setState({downloadProcessInventory: true, typeInfo:info})
        this.props.generateCSV(info, dates).then(
            (processID) => {
                console.log("[INFO], fetchDataStoreHouse, ",processID)
                this.setState({processID :  processID })
                this.fetchStatus(processID)
            }
        ).catch(
            (err) => {
                console.log("[ERROR], fetchDataStoreHouse, ",err)
            }
        )
    }

    handleDownloadInventory = () => {
        const processID = this.state.processID
        const type = this.state.typeInfo
        this.props.downloadCSV(processID,type)
        this.setState({
            downloadProcessInventory: false,
            linkAvailable:false,
            itemDownloaded: 0,
            totalItemToDownload: 0,
            dateForm : false,
            currentExt: "",
        })
    }
    render() {
        console.log('====================================');
        console.log("[STATE]", this.state);
        console.log('====================================');
        const { loading } = this.props;
        return (
            <PopUp
                maxWidth="sm"
                title="Templates Upload"
                close={this.props.handleClose}
            >
                {this.state.downloadProcessInventory &&
                    <Dialog
                        title="Extract Magasin Info"
                        block={true}
                        close={()=> this.stopInventoryProcess()}
                        // disabledSubmit={false}
                    >
                        <Box p={2}>

                            <Typography variant="caption" component="div" color="textSecondary">
                                Avancement {
                                    `${Math.round(this.state.progress)}%`
                                } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload} 
                            </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} />  */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownloadInventory}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
                <Box p={1}>
                    <Button 
                        style={{ backgroundColor : green[100]}}
                        variant="contained" 
                        onClick={() => this.fetchDataStoreHouse("temp-factures")} 
                        disabled={loading}
                    >
                        Link Factures 5000
                    </Button>
                </Box>
                {/* <Box p={1}>
                    <Button 
                        style={{ backgroundColor : green[100]}}
                        variant="contained" 
                        onClick={() => this.fetchDataStoreHouse("temp-priceList")} 
                        disabled={loading}
                    >
                        Grille Prix Produits
                    </Button>
                </Box> */}
                <Box p={1}>
                    <Button 
                        style={{ backgroundColor : green[100]}}
                        variant="contained" 
                        onClick={() => this.fetchDataStoreHouse("temp-product-info")} 
                        disabled={loading}
                    >
                        Prix Produits
                    </Button>
                </Box>
            </PopUp>
           
           );
    }
}

function mapStateToProps(state){
    return {
        loading: state.extract.fetching
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        generateCSV,
        statusCSV,
        downloadCSV
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(ExtractList);